module.exports = __webpack_public_path__ + "img/stickers-carte-identite.63d40cee.jpg";